import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import { EDIT_ACTION } from "constants/actions";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import {
  ACCOUNT_AGENCY,
  ACCOUNT_CONGRESSMAN,
  canEditRoles,
} from "utility/constants";
import { hasPermission } from "utility/helpers";

const getAccountAgency = (agencyIds, agencies, agency, type) => {
  let renderAgency = null;

  if (agencyIds && agencyIds.length !== 0) {
    const ag =
      agencies?.filter((_agency) => agencyIds.includes(_agency?.id)) ?? [];

    renderAgency =
      ag.length === agencies?.length
        ? "All Agencies"
        : ag.map((a) => a.acronym)?.join(", ");
  } else if (type === ACCOUNT_AGENCY) {
    renderAgency = agency;
  } else {
    renderAgency = "All Agencies";
  }

  return renderAgency;
};

const accountColumns = ({ agencies, user, navigate, handleDeleteAction }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Last Name",
      selector: (row) => row?.lastName,
      grow: 2,
      sortable: true,
      minWidth: "100px",
      cell: ({ lastName }) => <CellText>{lastName}</CellText>,
    },
    {
      name: "First Name",
      selector: (row) => row?.firstName,
      grow: 2,
      sortable: true,
      minWidth: "100px",
      cell: ({ firstName }) => <CellText>{firstName}</CellText>,
    },
    {
      name: "Role",
      selector: (row) => row?.type,
      grow: 2,
      sortable: true,
      cell: ({ type }) => <CellText>{type}</CellText>,
    },
    {
      name: "Agency",
      selector: (row) => row?.agency,
      grow: 2,
      sortable: true,
      cell: ({ agency, agencyIds, type }) => (
        <CellText>
          {getAccountAgency(agencyIds, agencies, agency, type)}
        </CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, { userId }) => (
        <>
          {user?.type === ACCOUNT_CONGRESSMAN ||
            (canEditRoles.includes(user.type) &&
              hasPermission("user-update") && (
                <>
                  <StyledEditIcon
                    size={16}
                    id={`edit-row--${userId}`}
                    onClick={() =>
                      navigate("/account", {
                        state: {
                          row,
                          action: EDIT_ACTION,
                        },
                      })
                    }
                  />

                  <UncontrolledTooltip
                    placement="auto"
                    target={`edit-row--${userId}`}
                  >
                    {"Edit"}
                  </UncontrolledTooltip>
                </>
              ))}

          {hasPermission("user-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${userId}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${userId}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default accountColumns;
